import { apiServiceConstants } from "../../../../constants/apiService.constants";
import { apiService } from "../../../../services/apiService";
import { utilService } from "../../../../services/utilService";
import {
  MediaItemDeleteModel,
  MediaShareInterface,
  MediaShareModel,
  MediaShareResultModel,
} from "./FileShareMediaList.model";

const getFileShareMediaListDetails = async (
  params: any
): Promise<MediaShareInterface> => {
  const respApiResult = await apiService
    .apiCall(
      `media-share/media-download/?reg_code=${utilService.getNetwork()}`,
      params,
      apiServiceConstants.GET,
      utilService.getDeviceType()
    )
    .then((res) => {
      const fileShareMediaListResp = res as MediaShareModel;
      var resultData: any;
      if (fileShareMediaListResp.result) {
        resultData = mapFileShareMediaListResult(fileShareMediaListResp.result);
      }
      const result: MediaShareInterface = {
        isSuccess: true,
        status: fileShareMediaListResp.status,
        message: fileShareMediaListResp.message,
        result: resultData,
      };
      return result;
    })
    .catch((err) => {
      const result: MediaShareInterface = {
        isSuccess: false,
        message: err.message,
        status: err.status,
      };
      return result;
    });

  return respApiResult;
};

const getMediaListHistoryDetails = async (
  params: any
): Promise<MediaShareInterface> => {
  const respApiResult = await apiService
    .apiCall(
      `media-share/media-history/?reg_code=${utilService.getNetwork()}`,
      params,
      apiServiceConstants.GET,
      utilService.getDeviceType()
    )
    .then((res) => {
      const mediaListHistoryResp = res as MediaShareModel;
      var resultData: any;
      if (mediaListHistoryResp.result) {
        resultData = mapFileShareMediaListResult(mediaListHistoryResp.result);
      }
      const result: MediaShareInterface = {
        isSuccess: true,
        status: mediaListHistoryResp.status,
        message: mediaListHistoryResp.message,
        result: resultData,
      };
      return result;
    })
    .catch((err) => {
      const result: MediaShareInterface = {
        isSuccess: false,
        message: err.message,
        status: err.status,
      };
      return result;
    });

  return respApiResult;
};

const deleteMediaListItem = async (
  params: any
): Promise<MediaItemDeleteModel> => {
  const respApiResult = await apiService
    .apiCall(
      `media-share/media-upload/?reg_code=${utilService.getNetwork()}`,
      params,
      apiServiceConstants.POST,
      utilService.getDeviceType()
    )
    .then((res) => {
      const fileShareMediaListResp = res as MediaItemDeleteModel;
      const result: MediaItemDeleteModel = {
        isSuccess: true,
        status: fileShareMediaListResp.status,
        message: fileShareMediaListResp.message,
      };
      return result;
    })
    .catch((err) => {
      const result: MediaItemDeleteModel = {
        isSuccess: false,
        message: err.message,
        status: err.status,
      };
      return result;
    });

  return respApiResult;
};

const mapFileShareMediaListResult = (payload: Array<MediaShareResultModel>) => {
  let resultListArray = payload.map((object: MediaShareResultModel) => {
    return {
      id: object.id,
      seen: object.seen,
      action: object.action,
      name: object.name,
      type: object.type,
      message: object.message,
      createdOn: object.created_on,
      namePath: object.name_path,
      guid: object.guid,
      url: object.url,
      smsThreadID: object.sms_thread_id,
      isExpired : object.is_expired
    };
  });
  return resultListArray;
};

const handleErrorResponse = () => {};

export const FileShareMediaListService = {
  getFileShareMediaListDetails,
  handleErrorResponse,
  deleteMediaListItem,
  getMediaListHistoryDetails,
};
